import { http } from '../lib/http';

/** `linkedAt` là Date phía server, sang JSON thành chuỗi ISO. */
export interface TelegramStatus {
  linked: boolean;
  chatId?: number | null;
  linkedAt?: string | null;
}

export const telegramService = {
  getStatus(): Promise<TelegramStatus> {
    return http.get('/telegrams/status');
  },

  getBotInfo(): Promise<{ username: string | null }> {
    return http.get('/telegrams/bot-info');
  },

  /** SINH mã liên kết gắn với tài khoản đang đăng nhập (không gửi body). */
  createCode(): Promise<{ code: string; expiresInSec: number }> {
    return http.post('/telegrams/link');
  },

  unlink(): Promise<null> {
    return http.post('/telegrams/unlink');
  },
};
